export default function Paiement() {
  const handlePayment = () => {
    window.open('https://checkout.revolut.com/pay/5623f5ed-f1fc-491b-bbd8-67f6d6a6f99c', '_blank');
  };

  return (
    <section id="paiement" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Paiement Sécurisé via Revolut
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Transactions rapides, sécurisées et sans frais cachés. Payez 35€ par lead pour accéder aux coordonnées complètes du client
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 shadow-2xl">
              <div className="flex items-center justify-between mb-8">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
                    <i className="ri-bank-card-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <div className="text-white font-bold text-lg">Paiement Revolut</div>
                    <div className="text-gray-400 text-sm">Sécurisé & Instantané</div>
                  </div>
                </div>
                <img 
                  src="https://public.readdy.ai/ai/img_res/9d7ac27fe1aa409fa5addb14ade32dbd.jpg"
                  alt="Revolut"
                  className="h-8 w-auto"
                />
              </div>

              <div className="space-y-6">
                <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm">
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-gray-300 text-sm">Lead Sélectionné</span>
                    <span className="text-white font-mono text-sm">LD-2024-001</span>
                  </div>
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-gray-300 text-sm">Type</span>
                    <span className="text-white text-sm">Réparation Fenêtre</span>
                  </div>
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-gray-300 text-sm">Région</span>
                    <span className="text-white text-sm">Nouvelle-Aquitaine</span>
                  </div>
                  <div className="border-t border-white/20 pt-4 mt-4">
                    <div className="flex items-center justify-between">
                      <span className="text-white font-bold text-lg">Prix du Lead</span>
                      <span className="text-blue-400 font-bold text-2xl">35 €</span>
                    </div>
                  </div>
                </div>

                <button 
                  onClick={handlePayment}
                  className="w-full bg-gradient-to-r from-blue-600 to-teal-600 text-white px-6 py-4 rounded-xl text-base font-bold hover:from-blue-700 hover:to-teal-700 transition-all transform hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer shadow-lg"
                >
                  <i className="ri-secure-payment-line text-xl"></i>
                  Payer avec Revolut
                  <i className="ri-arrow-right-line"></i>
                </button>

                <div className="flex items-center justify-center gap-4 text-xs text-gray-400">
                  <div className="flex items-center gap-1">
                    <i className="ri-shield-check-line"></i>
                    <span>Paiement Sécurisé</span>
                  </div>
                  <div className="w-1 h-1 bg-gray-600 rounded-full"></div>
                  <div className="flex items-center gap-1">
                    <i className="ri-lock-line"></i>
                    <span>Cryptage SSL</span>
                  </div>
                  <div className="w-1 h-1 bg-gray-600 rounded-full"></div>
                  <div className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    <span>Instantané</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Pourquoi Revolut ?
            </h3>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-flashlight-line text-2xl text-blue-600"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2 text-lg">Paiement Instantané</h4>
                <p className="text-gray-600">
                  Transactions en temps réel. Accédez immédiatement à vos leads après confirmation du paiement sans délai d'attente
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-shield-check-line text-2xl text-blue-600"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2 text-lg">Sécurité Maximale</h4>
                <p className="text-gray-600">
                  Protection bancaire de niveau européen avec authentification forte et cryptage de bout en bout pour toutes vos transactions
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-money-euro-circle-line text-2xl text-blue-600"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2 text-lg">Prix Unique : 35€</h4>
                <p className="text-gray-600">
                  Tarif fixe et transparent. Chaque lead qualifié à 35€, sans frais cachés ni commission supplémentaire
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-smartphone-line text-2xl text-blue-600"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2 text-lg">Simple & Rapide</h4>
                <p className="text-gray-600">
                  Interface intuitive et processus simplifié. Payez en quelques clics depuis votre ordinateur ou smartphone
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8 mb-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Comment Fonctionne le Paiement ?
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">1</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Sélectionnez</h4>
              <p className="text-sm text-gray-600">Choisissez le lead qui vous intéresse dans la liste disponible</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">2</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Cliquez sur Payer</h4>
              <p className="text-sm text-gray-600">Accédez au lien de paiement Revolut sécurisé généré automatiquement</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">3</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Validez 35€</h4>
              <p className="text-sm text-gray-600">Confirmez votre paiement via l'application Revolut en toute sécurité</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">4</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Accédez</h4>
              <p className="text-sm text-gray-600">Le lead se décrypte instantanément avec toutes les coordonnées</p>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-blue-50 to-teal-50 rounded-2xl p-8 border-2 border-blue-200">
          <div className="text-center max-w-3xl mx-auto">
            <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-price-tag-3-line text-4xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              Tarif Unique : 35€ par Lead
            </h3>
            <p className="text-lg text-gray-700 mb-6">
              Accédez à des leads qualifiés dans la réparation de fenêtres, baies vitrées et volets roulants pour seulement 35€. Prix fixe, sans surprise, sans abonnement.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
              <div className="bg-white rounded-lg p-4">
                <i className="ri-check-double-line text-2xl text-blue-600 mb-2"></i>
                <div className="font-bold text-gray-900">Leads Qualifiés</div>
                <div className="text-gray-600">Demandes vérifiées</div>
              </div>
              <div className="bg-white rounded-lg p-4">
                <i className="ri-user-line text-2xl text-blue-600 mb-2"></i>
                <div className="font-bold text-gray-900">Coordonnées Complètes</div>
                <div className="text-gray-600">Nom, téléphone, email</div>
              </div>
              <div className="bg-white rounded-lg p-4">
                <i className="ri-time-line text-2xl text-blue-600 mb-2"></i>
                <div className="font-bold text-gray-900">Accès Immédiat</div>
                <div className="text-gray-600">Après paiement</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
